export default {
  objects: [],
  background: "",
};
